module.exports = __webpack_public_path__ + "media/angular-engine/app/account/candidates/attributes/empty-f0377508b04586308779023130970f46.png";